import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DISPATCHER_PREFIX} from '../../../consts/data-service-consts';
import {Observable} from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class MxObjectService {

    constructor(private httpClient: HttpClient) {
    }

    saveNewObject(object: any, url: string): Observable<any> {
        return this.httpClient.post(DISPATCHER_PREFIX + url, this.constructFormData(object));
    }

    saveEditObject(object: any, url: string): Observable<any> {
        return this.httpClient.put(DISPATCHER_PREFIX + url, this.constructFormData(object));
    }

    getObject(url: string): Observable<any> {
        return this.httpClient.get<any>(DISPATCHER_PREFIX + url);
    }

    private doesContainFile(object: any): boolean {
        return Object.keys(object).find(value => object[value] instanceof File) !== undefined;
    }

    private constructFormData(object: any): any {
        if (this.doesContainFile(object)) {
            let formData: FormData = new FormData();

            Object.keys(object).forEach((value) => {
                if (object[value] instanceof File) {
                    formData.append(value, object[value], object[value].name);
                }
            });

            formData.append('body', new Blob([JSON.stringify(object)], {type: 'application/json'}));
            return formData;
        }
        return object;
    }
}
